(() => {
'use strict';
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];

/* Wishlist count badge in header */
function wishCount(){let n=0;try{const a=JSON.parse(localStorage.getItem('avagan:wishlist')||'[]');if(Array.isArray(a))n=a.length;}catch{}$$('[data-wishlist-count]').forEach(el=>{el.textContent=n;el.hidden=!n;});}
wishCount();
document.addEventListener('click',e=>{if(e.target.closest('[data-wishlist]'))setTimeout(wishCount,0);});
window.addEventListener('storage',wishCount);

/* Move product-page extras next to the buy area */
const extras=$('[data-pdp-extras]');
const anchor=$('.pdp-v2 .pdp-service');
if(extras&&anchor){anchor.before(extras);}

/* Delivery estimate (business days, viewer local time) */
$$('[data-delivery]').forEach(box=>{
  const d=box.dataset;const proc=+d.processing||3,min=+d.shipMin||5,max=+d.shipMax||8,cut=+d.cutoff||15;
  const addBiz=(date,n)=>{const x=new Date(date);while(n>0){x.setDate(x.getDate()+1);const w=x.getDay();if(w!==0&&w!==6)n--;}return x;};
  const fmt=x=>x.toLocaleDateString(undefined,{weekday:'short',month:'short',day:'numeric'});
  function render(){
    const now=new Date();const cutoff=new Date(now);cutoff.setHours(cut,0,0,0);
    let start=now;if(now>=cutoff){cutoff.setDate(cutoff.getDate()+1);start=cutoff;}
    const shipped=addBiz(start,proc);const a=addBiz(shipped,min),b=addBiz(shipped,max);
    const ms=cutoff-now;const h=Math.floor(ms/3600000),m=Math.floor(ms%3600000/60000);
    const cd=$('.dl-countdown',box),rg=$('.dl-range',box),sh=$('[data-dl-ship]',box),ar=$('[data-dl-arrive]',box),od=$('[data-dl-order]',box);
    if(cd)cd.textContent=h+'h '+m+'m';if(rg)rg.textContent=fmt(a)+' – '+fmt(b);
    if(od)od.textContent=fmt(now);if(sh)sh.textContent=fmt(shipped);if(ar)ar.textContent=fmt(a)+' – '+fmt(b);
  }
  render();setInterval(render,60000);
});

/* Gift finder quiz */
$$('[data-gift-quiz]').forEach(quiz=>{
  const steps=$$('.gq-step',quiz);const bars=$$('.gq-progress span',quiz);const back=$('[data-gq-back]',quiz);const skip=$('[data-gq-skip]',quiz);
  const state={};let i=0;const all=quiz.dataset.all||'/collections/all';
  function show(n){i=n;steps.forEach((s,k)=>s.hidden=k!==i);bars.forEach((b,k)=>b.classList.toggle('on',k<=i));back.hidden=i===0;const h=$('h2',steps[i]);if(h){h.setAttribute('tabindex','-1');h.focus({preventScroll:true});}}
  function finish(){
    let base=(state.recipient&&state.recipient.url)||(state.occasion&&state.occasion.url)||all;
    if(state.recipient&&state.occasion&&state.occasion.tag)base=base.replace(/\/$/,'')+'/'+encodeURIComponent(state.occasion.tag);
    const url=new URL(base,location.origin);if(url.origin!==location.origin)return;
    if(state.budget)url.searchParams.set('filter.v.price.lte',state.budget);
    location.assign(url.href);
  }
  function next(){if(i<steps.length-1)show(i+1);else finish();}
  quiz.addEventListener('click',e=>{const b=e.target.closest('[data-gq-key]');if(!b)return;const key=b.dataset.gqKey;$$('[data-gq-key="'+key+'"]',quiz).forEach(x=>x.setAttribute('aria-pressed',String(x===b)));state[key]=key==='budget'?b.dataset.value:{url:b.dataset.url,tag:b.dataset.tag};next();});
  back.addEventListener('click',()=>{if(i>0)show(i-1);});
  skip.addEventListener('click',()=>{const key=steps[i].dataset.key;delete state[key];next();});
  show(0);
});
})();
/* Sale countdown under price. endDate '' = ends at midnight each day (customer time); or set a real end like '2026-11-30T23:59:59' */
(function(){
var CFG={endDate:'',text:'Limited time offer ends in',hideWhenNoDiscount:true};
function num(t){var s=String(t||'').replace(/[^0-9.,]/g,'');if(/,\d{2}$/.test(s))s=s.replace(/\./g,'').replace(',','.');else s=s.replace(/,/g,'');var n=parseFloat(s);return isNaN(n)?0:n;}
function pad(n){return(n<10?'0':'')+n;}
function endTime(){if(CFG.endDate)return new Date(CFG.endDate).getTime();var d=new Date();d.setHours(24,0,0,0);return d.getTime();}
function init(){
var priceEl=document.querySelector('.price[data-price]');if(!priceEl||document.querySelector('.avg-cd'))return;
var row=priceEl.parentElement,box=document.createElement('div');box.className='avg-cd';
box.innerHTML='<div><div class="avg-cd-off"></div><div class="avg-cd-t">'+CFG.text+'</div></div><div class="avg-cd-r"><div><b data-u="h">00</b><span>Hours</span></div><div><b data-u="m">00</b><span>Min</span></div><div><b data-u="s">00</b><span>Sec</span></div></div>';
row.parentNode.insertBefore(box,row.nextSibling);
function updateOff(){var cmp=row.querySelector('[data-compare]');var p=num(priceEl.textContent),c=cmp?num(cmp.textContent):0;var pct=c>p&&p>0?Math.round((1-p/c)*100):0;box.querySelector('.avg-cd-off').textContent=pct+'% OFF';box.style.display=CFG.hideWhenNoDiscount&&!pct?'none':'';}
updateOff();new MutationObserver(updateOff).observe(row,{subtree:true,childList:true,characterData:true});
var H=box.querySelector('[data-u=h]'),M=box.querySelector('[data-u=m]'),S=box.querySelector('[data-u=s]'),timer;
function tick(){var ms=endTime()-Date.now();if(ms<=0&&CFG.endDate){box.remove();clearInterval(timer);return;}var s=Math.max(0,Math.floor(ms/1000));H.textContent=pad(Math.floor(s/3600));M.textContent=pad(Math.floor(s%3600/60));S.textContent=pad(s%60);}
tick();timer=setInterval(tick,1000);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* Product accordions: icons + Personalization tab */
(function(){
var IC={d:'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z',s:'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z',p:'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'};
var PERSONALIZATION='<ul class="avg-acc-list"><li>Please double-check spelling, capitalization and punctuation &ndash; we print your text exactly as entered.</li><li>The preview is a digital mockup. Colors and placement may vary slightly on the finished product.</li><li>Every item is made to order just for you. Need a change? Contact us right after ordering and we will do our best to help.</li></ul>';
function svg(k){return '<svg class="avg-acc-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="'+IC[k]+'"/></svg>';}
function init(){
var acc=[].slice.call(document.querySelectorAll('details.pdp-accordion'));if(!acc.length||document.querySelector('.avg-acc-ic'))return;
acc.forEach(function(d){var s=d.querySelector('summary');if(!s)return;var t=s.textContent.trim();var k=/ship/i.test(t)?'s':/personal/i.test(t)?'p':'d';if(k==='s')t='Shipping & Returns';s.innerHTML=svg(k)+'<span>'+t+'</span>';});
var hasP=acc.some(function(d){return /personal/i.test(d.querySelector('summary').textContent);});
if(!hasP){var p=document.createElement('details');p.className='pdp-accordion';p.innerHTML='<summary>'+svg('p')+'<span>Personalization</span></summary><div class="rte">'+PERSONALIZATION+'</div>';acc[acc.length-1].after(p);}
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* Star rating under product title (only when the product has reviews) */
(function(){
function init(){
var h=document.querySelector('.product-info h1');var p=document.querySelector('[data-avr] [data-pane=item]');
if(!h||!p||document.querySelector('.avr-mini'))return;
var n=p.querySelectorAll('.avr-rev').length;if(!n)return;
var avg=parseFloat((p.querySelector('.avr-big')||{}).textContent)||5;
var a=document.createElement('a');a.className='avr-mini';a.href='#reviews';
a.innerHTML='<span class="avr-mini-s" style="--v:'+(avg*20)+'%">★★★★★</span><span>'+avg.toFixed(1)+' ('+n+')</span>';
h.after(a);
a.addEventListener('click',function(e){e.preventDefault();var t=document.querySelector('[data-avr] [data-tab=item]');if(t)t.click();var r=document.getElementById('reviews');if(r)r.scrollIntoView({behavior:'smooth'});});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
/* Add-to-cart popup: shows the item just added (TeeInBlue preview if any), options, qty, price. Replaces the cart drawer after adding. */
(function () {
if (window.__avgAtc) return; window.__avgAtc = true;
var CART_URL = '/cart';
var css = '' +
'.avg-atc{position:fixed;inset:0;z-index:2147483000;background:rgba(20,16,14,.55);display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .2s}' +
'.avg-atc.on{opacity:1}' +
'.avg-atc-box{background:#fff;border-radius:16px;padding:16px;width:min(600px,100%);max-height:92vh;overflow:auto;box-shadow:0 20px 60px rgba(0,0,0,.25);font-size:14px;color:#2b2420}' +
'.avg-atc-ok{display:flex;align-items:center;gap:8px;color:#2a8a6a;font-weight:600;margin-bottom:12px}' +
'.avg-atc-ok svg{width:18px;height:18px;flex:none}' +
'.avg-atc-row{display:grid;grid-template-columns:minmax(0,280px) 1fr;gap:14px}' +
'.avg-atc-img{aspect-ratio:1;border:1px solid #eee7e0;border-radius:8px;overflow:hidden;background:#faf7f4}' +
'.avg-atc-img img{width:100%;height:100%;object-fit:contain;display:block}' +
'.avg-atc-t{font-weight:500;line-height:1.35;margin:0 0 10px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
'.avg-atc-o{font-size:12.5px;color:#6f655d;margin:3px 0}.avg-atc-o b{color:#2b2420;font-weight:600}' +
'.avg-atc-p{color:#f26a2e;font-weight:700;font-size:17px;margin-top:16px}' +
'.avg-atc-p s{color:#9a9089;font-weight:400;font-size:13px;margin-left:6px}' +
'.avg-atc-btns{display:grid;grid-template-columns:minmax(0,280px) 1fr;gap:14px;margin-top:12px}' +
'.avg-atc-btns a,.avg-atc-btns button{display:flex;align-items:center;justify-content:center;gap:6px;height:46px;border-radius:999px;font:inherit;font-weight:600;font-size:14px;text-decoration:none;cursor:pointer;border:0}' +
'.avg-atc-keep{background:#f4f1ee;color:#2b2420}' +
'.avg-atc-go{background:#f26a2e;color:#fff}' +
'@media (max-width:520px){.avg-atc-row,.avg-atc-btns{grid-template-columns:1fr}.avg-atc-img{max-width:220px}}';
var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function money(cents) {
var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100) + ' ' + cur; }
catch (e) { return '$' + (cents / 100).toFixed(2); }
}
function isImg(v) { return typeof v === 'string' && /^(https?:)?\/\//.test(v) && /\.(png|jpe?g|webp|gif|avif)(\?|$)|image|preview|mockup/i.test(v); }
function previewsOf(item) {
var p = item.properties || {}, keys = Object.keys(p), out = [];
keys.filter(function (k) { return /customization_image/i.test(k); })
.concat(keys.filter(function (k) { return /preview|mockup|thumbnail/i.test(k); }))
.forEach(function (k) { if (isImg(p[k]) && out.indexOf(p[k]) < 0) out.push(p[k]); });
var prod = (item.featured_image && item.featured_image.url) || item.image;
if (prod) out.push(prod);
return out.map(function (s) { return s.indexOf('//') === 0 ? 'https:' + s : s; });
}
function show(item) {
var old = document.querySelector('.avg-atc'); if (old) old.remove();
var opts = (item.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
.map(function (o) { return '<div class="avg-atc-o">' + esc(o.name) + ': <b>' + esc(o.value) + '</b></div>'; }).join('');
var price = item.final_line_price != null ? item.final_line_price : item.line_price;
var orig = item.original_line_price;
var imgs = previewsOf(item), img = imgs[0];
var wrap = document.createElement('div'); wrap.className = 'avg-atc'; wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');
wrap.innerHTML =
'<div class="avg-atc-box">' +
'<div class="avg-atc-ok"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M4 12.5l5 5L20 6.5"/></svg>Item has been added to your shopping cart</div>' +
'<div class="avg-atc-row">' +
'<div class="avg-atc-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '">' : '') + '</div>' +
'<div><p class="avg-atc-t">' + esc(item.product_title || item.title) + '</p>' + opts +
'<div class="avg-atc-o">Quantity: <b>' + esc(item.quantity) + '</b></div>' +
'<div class="avg-atc-p">' + money(price) + (orig > price ? '<s>' + money(orig) + '</s>' : '') + '</div></div>' +
'</div>' +
'<div class="avg-atc-btns"><button type="button" class="avg-atc-keep">Keep Shopping</button>' +
'<a class="avg-atc-go" href="' + CART_URL + '">View Cart &amp; Checkout <span aria-hidden="true">&#8250;</span></a></div>' +
'</div>';
document.body.appendChild(wrap);
    /* show the customer's live TeeInBlue design (some mockups render without the artwork) */
    (function () { var sv = document.querySelector('.tee-mockup-artwork__wrapper svg'); var tc = window.teeinblueCampaign; if (!sv || !tc || String(tc.productId) !== String(item.product_id)) return; var box = wrap.querySelector('.avg-atc-img'); var c = sv.cloneNode(true); c.removeAttribute('id'); c.setAttribute('width', '100%'); c.setAttribute('height', '100%'); c.style.display = 'block'; box.innerHTML = ''; box.appendChild(c); })();
var im = wrap.querySelector('.avg-atc-img img'), n = 0;
if (im) im.addEventListener('error', function () { n++; if (imgs[n]) im.src = imgs[n]; else im.remove(); });
requestAnimationFrame(function () { wrap.classList.add('on'); });
var close = function () { wrap.classList.remove('on'); setTimeout(function () { wrap.remove(); }, 200); document.removeEventListener('keydown', onKey); };
var onKey = function (e) { if (e.key === 'Escape') close(); };
document.addEventListener('keydown', onKey);
wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('.avg-atc-keep')) close(); });
wrap.querySelector('.avg-atc-keep').focus();
}
var addedAt = 0;
function closeDrawer() {
var d = document.getElementById('cart-drawer');
if (!d || !d.open) return;
var x = d.querySelector('[data-close-dialog]');
if (x) x.click(); else d.close();
}
function watchDrawer() {
var d = document.getElementById('cart-drawer');
if (!d) return;
new MutationObserver(function () { if (d.open && Date.now() - addedAt < 6000) setTimeout(closeDrawer, 0); })
.observe(d, { attributes: true, attributeFilter: ['open'] });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
function handle(data) {
var item = data && (data.items ? data.items[data.items.length - 1] : data);
if (!item || !item.key) return;
addedAt = Date.now(); closeDrawer();
fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
var line = (cart.items || []).filter(function (i) { return i.key === item.key; })[0];
show(Object.assign({}, item, line || {}, { quantity: item.quantity }));
}).catch(function () { show(item); });
}
function isAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); }
var oFetch = window.fetch;
if (oFetch) window.fetch = function (input, init) {
var url = typeof input === 'string' ? input : (input && input.url);
var p = oFetch.apply(this, arguments);
if (isAdd(url)) p.then(function (r) { if (r.ok) r.clone().json().then(handle).catch(function () {}); }).catch(function () {});
return p;
};
var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open = function (m, url) { this.__avgAdd = isAdd(url); return oOpen.apply(this, arguments); };
XMLHttpRequest.prototype.send = function () {
if (this.__avgAdd) this.addEventListener('load', function () {
if (this.status >= 200 && this.status < 300) { try { handle(JSON.parse(this.responseText)); } catch (e) {} }
});
return oSend.apply(this, arguments);
};
})();

/* Review photos: adds "Add photos" to the Write a Review form (.avr-form).
   Photos are resized in the browser, uploaded to Uploadcare, and their links are
   sent with the review email as "Photos". */
(function () {
  var UPLOADCARE_KEY = '75269ddffdcd5c70f71e';
  var CDN = 'https://19m2e74cnr.ucarecd.net'; // this project's Uploadcare CDN
  var MAX_FILES = 3, MAX_MB = 15, MAX_SIDE = 1600;

  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  if (!UPLOADCARE_KEY || /PASTE_/.test(UPLOADCARE_KEY)) return;

  var css = '' +
    '.avr-ph{margin:0 0 14px}.avr-ph-l{font-size:13px;font-weight:500;margin-bottom:6px}' +
    '.avr-ph-row{display:flex;flex-wrap:wrap;gap:8px}' +
    '.avr-ph-add{width:72px;height:72px;border:1.5px dashed #c9bfb5;border-radius:10px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;cursor:pointer;color:#6f655d;font-size:11px;background:#faf7f4}' +
    '.avr-ph-add svg{width:20px;height:20px}.avr-form .avr-ph-add{display:flex;margin:0;font-weight:400}.avr-form .avr-ph input[type=file]{display:none}' +
    '.avr-ph-it{position:relative;width:72px;height:72px;border-radius:10px;overflow:hidden;border:1px solid #e6ded6}' +
    '.avr-ph-it img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.avr-ph-x{position:absolute;top:3px;right:3px;width:20px;height:20px;border-radius:50%;border:0;background:rgba(0,0,0,.6);color:#fff;font-size:13px;line-height:20px;padding:0;cursor:pointer}' +
    '.avr-ph-h{font-size:11.5px;color:#8a8079;margin-top:6px}.avr-ph-err{color:#c0392b}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function resize(file) {
    return new Promise(function (res) {
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var k = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
        var c = document.createElement('canvas'); c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); x.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { res(b || file); }, 'image/jpeg', 0.86);
      };
      img.onerror = function () { URL.revokeObjectURL(url); res(file); };   // e.g. HEIC: upload as is
      img.src = url;
    });
  }
  function upload(blob, name) {
    var fd = new FormData();
    fd.append('UPLOADCARE_PUB_KEY', UPLOADCARE_KEY);
    fd.append('UPLOADCARE_STORE', '1');
    fd.append('file', blob, name);
    return fetch('https://upload.uploadcare.com/base/', { method: 'POST', body: fd })
      .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
      .then(function (j) { return CDN.replace(/\/$/, '') + '/' + j.file + '/'; });
  }

  function enhance(form) {
    if (form.__avrPh) return; form.__avrPh = true;
    var files = [];
    var box = document.createElement('div'); box.className = 'avr-ph';
    box.innerHTML = '<div class="avr-ph-l">Add photos <span style="font-weight:400;color:#8a8079">(optional, up to ' + MAX_FILES + ')</span></div>' +
      '<div class="avr-ph-row"><label class="avr-ph-add"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 7h3l2-2h6l2 2h3v12H4z"/><circle cx="12" cy="13" r="3.5"/></svg>Add photo' +
      '<input type="file" accept="image/*" multiple hidden></label></div><div class="avr-ph-h"></div>';
    var row = box.querySelector('.avr-ph-row'), add = box.querySelector('.avr-ph-add'), input = box.querySelector('input'), hint = box.querySelector('.avr-ph-h');
    var btn = form.querySelector('button[type=submit],input[type=submit]') || form.querySelector('button');
    (btn && btn.parentNode === form ? btn : form.lastElementChild).insertAdjacentElement('beforebegin', box);

    function msg(t, err) { hint.textContent = t || ''; hint.classList.toggle('avr-ph-err', !!err); }
    function draw() {
      row.querySelectorAll('.avr-ph-it').forEach(function (e) { e.remove(); });
      files.forEach(function (f, i) {
        var d = document.createElement('div'); d.className = 'avr-ph-it';
        d.innerHTML = '<img alt=""><button type="button" class="avr-ph-x" aria-label="Remove photo">&times;</button>';
        d.querySelector('img').src = f.preview;
        d.querySelector('button').onclick = function () { URL.revokeObjectURL(f.preview); files.splice(i, 1); draw(); };
        row.insertBefore(d, add);
      });
      add.style.display = files.length >= MAX_FILES ? 'none' : '';
    }
    input.addEventListener('change', function () {
      var skipped = 0;
      Array.prototype.forEach.call(input.files, function (f) {
        if (files.length >= MAX_FILES || !/^image\//.test(f.type) || f.size > MAX_MB * 1048576) { skipped++; return; }
        files.push({ file: f, preview: URL.createObjectURL(f) });
      });
      input.value = ''; draw();
      msg(skipped ? 'Some photos were skipped (max ' + MAX_FILES + ' photos, ' + MAX_MB + ' MB each).' : '', !!skipped);
    });

    form.addEventListener('submit', function (e) {
      if (!files.length || form.__avrSending) return;
      e.preventDefault();
      if (!form.reportValidity()) return;
      form.__avrSending = true;
      var label = btn ? (btn.value || btn.textContent) : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Uploading photos…'; }
      msg('');
      Promise.all(files.map(function (f, i) {
        return resize(f.file).then(function (b) { return upload(b, 'review-photo-' + (i + 1) + '.jpg'); });
      })).then(function (urls) {
        var h = form.querySelector('input[name="contact[Photos]"]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'contact[Photos]'; form.appendChild(h); }
        h.value = urls.join('\n');
        HTMLFormElement.prototype.submit.call(form);
      }).catch(function () {
        form.__avrSending = false;
        if (btn) { btn.disabled = false; btn.textContent = label; }
        msg('Photo upload failed. Please try again, or remove the photos to send your review without them.', true);
      });
    });
  }

  ready(function () {
    document.querySelectorAll('form.avr-form').forEach(enhance);
    new MutationObserver(function () { document.querySelectorAll('form.avr-form').forEach(enhance); })
      .observe(document.body, { childList: true, subtree: true });
  });
})();

/* Avagan CRO fixes for ad traffic.
   1. Mobile header: hide the "Trending" row after the first scroll.
   2. Sticky buy bar: clearer CTA with price; hides while the real Add to cart button is on screen.
   3. Back-to-top bubble: hidden on mobile product pages.
   4. Trust line right under Add to cart.
   5. Reviews: if the item has no reviews yet, open the Store Reviews tab.
   6. Rating line under the title links to the reviews section. */
(function () {
  if (window.__avgCro) return; window.__avgCro = true;
  var mq = window.matchMedia('(max-width: 749px)');
  var isProduct = /\btemplate-product\b/.test(document.body.className);
  var css = '' +
    '@media (max-width:749px){' +
      '.site-header.avg-compact .trending-terms{display:none!important}' +
      'body[class*="template-product"] .to-top{display:none!important}' +
      '.sticky-buy{transition:transform .2s ease}' +
      '.sticky-buy.avg-off{transform:translateY(110%)}' +
      '.sticky-buy button{font-weight:700;letter-spacing:.01em}' +
    '}' +
    '.avg-trust{display:flex;flex-wrap:wrap;justify-content:center;gap:6px 14px;margin:10px 0 2px;font-size:12.5px;color:#4a3f37}' +
    '.avg-trust span{display:inline-flex;align-items:center;gap:5px;white-space:nowrap}' +
    '.avg-trust svg{width:14px;height:14px;color:#2a8a6a;flex:none}' +
    '.avg-rate{display:inline-flex;align-items:center;gap:6px;margin:4px 0 8px;font-size:13px;color:#4a3f37;text-decoration:none}' +
    '.avg-rate b{color:#2b2420;letter-spacing:1px;font-weight:400;font-size:15px;line-height:1}' +
    '.avg-rate span{color:#8a8079;font-size:12px}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  var tick = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"><path d="M4 12.5l5 5L20 6.5"/></svg>';
  ready(function () {
    var header = document.querySelector('.site-header');
    if (header) {
      var onScroll = function () { header.classList.toggle('avg-compact', mq.matches && window.scrollY > 60); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    if (!isProduct) return; var __n = 0; (function go() { if (!Array.prototype.some.call(document.querySelectorAll('form[action*="/cart/add"] button[type=submit]'), function (b) { return b.offsetParent !== null; }) && __n++ < 40) { setTimeout(go, 250); return; }
    var atc = Array.prototype.find.call(document.querySelectorAll('form[action*="/cart/add"] button[type=submit], form[action*="/cart/add"] [name=add]'),
      function (b) { return b.offsetParent !== null; });
    var bar = document.querySelector('.sticky-buy'), barBtn = bar && bar.querySelector('button');
    if (barBtn) {
      var priceEl = document.querySelector('.price[data-price]');
      var setLabel = function () {
        var p = priceEl ? priceEl.textContent.trim().replace(/\s*USD$/, '') : '';
        var t = 'Personalize Now' + (p ? ' \u00b7 ' + p : '');
        if (barBtn.textContent !== t) barBtn.textContent = t;
      };
      setLabel();
      if (priceEl) new MutationObserver(setLabel).observe(priceEl, { childList: true, characterData: true, subtree: true });
      if (atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { bar.classList.toggle('avg-off', es[0].isIntersecting); }, { threshold: 0.3 }).observe(atc);
      }
    }
    if (atc && !document.querySelector('.avg-trust')) {
      var row = atc.closest('.pdp-purchase, .product-form__buttons') || atc.parentNode;
      var t = document.createElement('div'); t.className = 'avg-trust';
      t.innerHTML = '<span>' + tick + '30-Day Refund</span><span>' + tick + 'Free Replacement if Damaged</span><span>' + tick + 'Secure Checkout</span>';
      row.parentNode.insertBefore(t, row.nextSibling);
    }
    var itemPane = document.querySelector('[data-pane="item"]');
    var storeTab = document.querySelector('button[data-tab="store"]');
    if (itemPane && storeTab && /No reviews yet/i.test(itemPane.textContent)) storeTab.click();
    var title = document.querySelector('.product-info h1, main h1');
    var storePane = document.querySelector('[data-pane="store"]');
    var m = storePane && storePane.textContent.match(/(\d\.\d)\s*(\d+)\s*Reviews/i);
    if (title && m && !document.querySelector('.avr-mini, .avg-rate')) {
      var a = document.createElement('a'); a.className = 'avg-rate'; a.href = '#';
      a.innerHTML = '<b>★★★★★</b><span>(' + m[2] + ')</span>';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        (storePane.closest('.shopify-section') || storePane).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      title.insertAdjacentElement('afterend', a);
    }
        })();
  });
})();
